import apiClient from '@/lib/api/apiClient'
import type { LinkApplicantPayload, SwapContactsPayload } from '../types/services'
import { throwServiceError } from './serviceHelpers'

/** Link applicant. */
export async function linkApplicant(
  applicantId: string | number,
  linkData: LinkApplicantPayload,
): Promise<void> {
  try {
    await apiClient.post(`/api/link_applicant/${applicantId}`, linkData)
  } catch (error) {
    throwServiceError(error, 'Failed to link applicant.')
  }
}

/** Swap contacts between co-applicants. */
export async function swapContacts(
  _applicantId: string | number,
  swapData: SwapContactsPayload,
): Promise<void> {
  try {
    await apiClient.post(`/api/swap_applicant_info`, swapData)
  } catch (error) {
    throwServiceError(error, 'Failed to swap contacts.')
  }
}

/** Link co-applicant. */
export async function linkCoApplicant(
  applicationId: string | number,
  applicantId: string | number,
): Promise<void> {
  try {
    await apiClient.post(`/api/link_coapplicant`, {
      application_id: applicationId,
      applicant_id: applicantId,
    })
  } catch (error) {
    throwServiceError(error, 'Failed to link co-applicant.')
  }
}

/** Remove co-applicant. */
export async function removeCoApplicant(applicantId: string | number): Promise<void> {
  try {
    await apiClient.delete(`/api/link_coapplicant/${applicantId}`)
  } catch (error) {
    throwServiceError(error, 'Failed to remove co-applicant.')
  }
}

/** Separate co-applicant from main application. */
export async function separateCoApplicant(
  applicationId: string | number,
  applicantId: string | number,
): Promise<void> {
  try {
    await apiClient.post(`/api/separate_coapplicant`, {
      application_id: applicationId,
      applicant_id: applicantId,
    })
  } catch (error) {
    throwServiceError(error, 'Failed to separate co-applicant.')
  }
}
